module.exports = __webpack_public_path__ + "img/bc_icon_dark.52ab6be.png";